<app-card #card
    [cardTitle]="'EMPLOYEE_REVIEW_PERIOD.EMPLOYEES_IN_ASSESSMENT' | translate"
    [useExternalButtons]="true"
    [showEdit]="isEditable"
    [disabled]="!settingState.reviewPeriod.value">

    <div>
        <div>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'EMPLOYEE_REVIEW_PERIOD.SEARCH' | translate }}</mat-label>
                <input matInput type="text" [formControl]="searchControl" autocomplete="off">
                <button *ngIf="searchControl.value" matSuffix mat-icon-button [attr.aria-label]="'EMPLOYEE_REVIEW_PERIOD.CLEAR' | translate" (click)="clearText()">
                  <mat-icon>close</mat-icon>
                </button>
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>

            <ng-container *ngIf="items$ | async as items">
                <div class="message-panel">
                    {{ searchMessage }}
                </div>
                <div class="scroll-panel">
                    <app-dynamic-list-item (delete)="removeEmployee(item)" [actionState]="card.actionState" [noEdit]="true" *ngFor="let item of items; index as i" [index]="i" [source]="item">
                        <div slot="readonly">
                            <div class="flex-horizontal mainitems" [ngClass]="{'deleted': item.itemSource.employeeStatus == employeeStatusList.Deleted}">
                                <div class="field-index">{{ (page * pageSize) + i + 1 }}</div>
                                <div class="field-text">
                                    <div class="name"><strong>{{ item.itemSource.name }}</strong></div>
                                    <div class="sub-text inactive-user-label" *ngIf="EmployeeHelper.isEmployeeInactive(item.itemSource)">
                                        {{ 'EMPLOYEE.INACTIVE_USER_LABEL' | translate }}
                                    </div>
                                    <div class="sub-text">
                                        <span>{{ item.itemSource.email ?? item.itemSource.userName }} </span>
                                        <span [title]="'EMPLOYEE_REVIEW_PERIOD.UNIQUE_EMPLOYEE_IDENTIFIER' | translate">{{ item.itemSource.employeeIdentifier ?? '' }}</span>
                                    </div>
                                    <div class="sub-text" *ngIf="isGoalPeriod">
                                        <span>{{ 'EMPLOYEE_REVIEW_PERIOD.GOAL_STATUS' | translate }}</span>&nbsp;<span class="goal-state">{{ getGoalStatusText(item.itemSource.goalPeriodStatus) }}</span>
                                    </div>
                                    <div class="sub-text">
                                        <span>{{ item.itemSource.isAuraLeader ? ('EMPLOYEE_REVIEW_PERIOD.AURA_LEADER' | translate) : '' }} </span>
                                    </div>
                                    <div class="sub-text" *ngIf="isGoalPeriod">
                                        <mat-checkbox [disabled]="!isEditable || (!state.isAdmin && !state.isSuperAdmin)" [ngModel]="item.itemSource.isGoalEvaluationTarget" (ngModelChange)="onIsGoalEvaluationTargetChange(item.itemSource, $event)">
                                            {{ 'EMPLOYEE_REVIEW_PERIOD.IS_GOAL_EVALUATION_TARGET' | translate }}
                                        </mat-checkbox>
                                    </div>
                                </div>
                                <div class="field-icons flex-horizontal mainitems" *ngIf="isGoalPeriod && item.itemSource.isGoalEvaluationTarget">
                                    <a mat-flat-button class="widget-button button-bg-alt1" [routerLink]="['/goals', reviewPeriodId, item.itemSource.id]" [queryParams]="{ returnUrl: 'settings' }">{{ 'EMPLOYEE_REVIEW_PERIOD.EVALUATION_FORM' | translate }}</a>
                                </div>
                            </div>

                        </div>
                    </app-dynamic-list-item>
                </div>
                <mat-paginator #paginator [length]="total"
                            [pageSize]="pageSize"
                            [pageSizeOptions]="pageSizeOptions"
                            (page)="pagingSettingsChanged($event)"
                            [attr.aria-label]="'EMPLOYEE_REVIEW_PERIOD.CHOOSE_PAGE' | translate">
                </mat-paginator>
                <app-search *ngIf="card.actionState.editMode" (add)="addEmployee($event)" [placeholder]="isAura ? ('EMPLOYEE_REVIEW_PERIOD.ADD_LEADER' | translate) : ''"  [inlineButtons]="true" [isAllowSearch]="true" [config]="searchEmployeeConfig"></app-search>
            </ng-container>
            
        </div>        
    </div>
</app-card>
